// SECTIONS

import {initnavigation} from './js/navigation';
import {initgallery} from './js/gallery';
import {initvorschau} from './js/vorschau';
import {initanimate} from './js/animate';
import { initmanuskripte } from './js/manuskripte';
import {initkalender} from './js/kalender';

// INIT

init();

function init(){

    initnavigation();
    initgallery();
    initvorschau();
    initanimate();
    initmanuskripte();
    initkalender();
    
}